import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'safeDate'
})
export class SafeDatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!value || isNaN(new Date(value).getTime())) {
      return 'none';
    }
    return value;
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/safe-date.pipe.ts